import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../contexts/user.context";
import {
  auth,
  createNewUser,
  getApartmentList,
} from "../utils/firebase/firebase.utils";

const CreateBookingPage = () => {
  const currentUser = auth.currentUser;
  const navigate = useNavigate();
  const [arrivalDateString, setArrivalDateString] = useState();
  const [revenue, setRevenue] = useState();
  const [password, setPassword] = useState();
  const [apartmentList, setApartmentList] = useState([]);
  const [selectedApartment, setSelectedApartment] = useState();
  const [loading, setLoading] = useState(false);
  const [showReponseMessage, setShowResponseMessage] = useState(false);
  const [creationResponse, setCreationResponse] = useState({
    success: false,
    link: "",
  });

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    console.log(selectedApartment, revenue, arrivalDateString);
    try {
      const response = await createNewUser(
        selectedApartment,
        revenue,
        arrivalDateString
      );
      setShowResponseMessage(true);
      setCreationResponse(response);
    } catch (error) {
      console.log(error);
      alert("Fehler bei der Erstellung, check die Console");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!currentUser) {
      navigate("/admin");
    } else if (currentUser.uid !== "tVQXHYIlGURh3w0wQ1jbzzjMDJq1") {
      navigate("/admin");
    }

    const newList = async () => {
      const aptList = await getApartmentList();
      setApartmentList(aptList);
      console.log("ran");
      setSelectedApartment(aptList[0].apartmentId);
      console.log(aptList);
      console.log(selectedApartment);
    };

    newList();
  }, []);

  const setActiveApartment = (e) => {
    console.log(e);
    setSelectedApartment(e.target.value);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        margin: "12px",
        marginTop: "24px",
        alignItems: "center",
      }}
    >
      {showReponseMessage ? (
        <div
          style={{
            backgroundColor: creationResponse.success ? "lightgreen" : "red",
            borderRadius: 12,
            padding: 12,
            margin: 8,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: "90%",
            maxWidth: 800
          }}
        >
          <p style={{fontWeight: 600, fontSize: 16}}>  
            {creationResponse.success
              ? "User erfolgreich erstellt"
              : "Fehler bei der User Erstellung"}
          </p>
          {creationResponse.success ? (
            <button
              style={{
                backgroundColor: "black",
                padding: 12,
                border: "none",
                fontWeight: 600,
                marginTop: 8,
                borderRadius: 8,
                color: "white",
                cursor: "pointer"
              }}
              onClick={() => {
                navigator.clipboard.writeText(creationResponse.link);
              }}
            >
              Link kopieren
            </button>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}
      <h1 style={{ fontSize: 24, marginBottom: 12 }}>Create new Booking</h1>
      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          width: "100%",
          maxWidth: 800,
        }}
      >
        <label style={{ marginBottom: 8, marginTop: 12 }} htmlFor="dateInput">
          Ankunftsdatum
        </label>
        <input
          style={{
            minHeight: 36,
            borderRadius: 12,
            border: "1px solid black",
            paddingInline: 12,
            marginBottom: "8px",
          }}
          type="date"
          name="dateInput"
          onChange={(e) => setArrivalDateString(e.target.value)}
          required
        ></input>
        <label style={{ marginBottom: 8, marginTop: 12 }} htmlFor="revenue">
          Umsatz
        </label>
        <input
          style={{
            minHeight: 36,
            borderRadius: 12,
            border: "1px solid black",
            paddingInline: 12,
            height: "20px",
            marginBottom: "8px",
          }}
          type="number"
          step={0.01}
          name="revenue"
          required
          onChange={(e) => setRevenue(e.target.value)}
        ></input>
        <label style={{ marginBottom: 8, marginTop: 12 }} htmlFor="apartments">
          Apartment wählen
        </label>
        <select
          id="apartments"
          onChange={setActiveApartment}
          style={{
            minHeight: 36,
            borderRadius: 12,
            paddingInline: 8,
            border: "1px solid black",
          }}
        >
          {apartmentList.map((app, index) => {
            return (
              <option key={index} value={app.apartmentId} label={app.name}>
                {" "}
              </option>
            );
          })}
        </select>

        <button
          style={{
            backgroundColor: "black",
            padding: 12,
            border: "none",
            fontWeight: 600,
            marginTop: 24,
            borderRadius: 8,
            color: "white",
          }}
          type="submit"
        >
          {loading ? "Lädt" : "Erstellen"}
        </button>
      </form>
      <button
        style={{
          padding: 12,
          border: "none",
          textDecoration: "none",
          marginTop: 12,
          borderRadius: 8,
          width: "100%",
          maxWidth: 800,
        }}
        onClick={() => navigate("/admin/dashboard")}
      >
        Zurück zum Dashboard
      </button>
    </div>
  );
};

export default CreateBookingPage;
